import React, { useEffect } from "react";
import { FaMap, FaShoppingCart, FaStar } from "react-icons/fa";
import noItemImg from "../../assets/images/noItem.svg";
import { Config } from "../../Config";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ShowMap from "../ShowMap/ShowMap";
import { toast } from "react-toastify";
import { addToCart } from "../../Redux/Actions";
import { MdOutlineArrowDropDownCircle } from "react-icons/md";
import "./Responsive.scss";
import "./Service.scss";

const Service = (props) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const addToCartHandler = async (isApproved, providerId, e, price, pi) => {
    if (!user[0]?.token) {
      props.history.push({
        pathname: "/login",
        state: { prevPath: `/products/${props.productId}/${props.productName}` },
      });
      return;
    }
    if (isApproved) {
      if (!user[0].chassisNumber || !user[0].engineNumber || !user[0].nationalCode) {
        toast("لطفا ابتدا اطلاعات پروفایل خود را تکمیل کنید");
        props.history.push("/profile");
        return;
      }
    }
    let btns = document.querySelectorAll(".addToCartBtn");
    // e.target.classList.add("invalidInput");
    btns.forEach((i) => i.classList.add("invalidInput"));
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

    let raw = JSON.stringify({
      productId: props.productId,
      Count: 1,
      providerId: providerId,
      isApprovedPrice: isApproved,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(Config.apiPath + "/orders/addtocart", requestOptions)
      .then((response) => {
        if (response.status === 404) {
          toast.error("امکان خرید با سهمیه دولتی برای شما وجود ندارد");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.status === 200) {
          let newProduct = Object.assign(props.product, {
            orderDetailId: result.data.orderDetailId,
            unitPrice: price,
            isApproved: isApproved,
            providerId: pi,
          });
          dispatch(addToCart(newProduct));
        } else {
          toast.error(<div>{result.messages}</div>);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
    // e.target.classList.remove("invalidInput");
    btns.forEach((i) => i.classList.remove("invalidInput"));
  };

  const showAllhandler = () => {
    let options = document.querySelectorAll(".serviceOptions");
    options.forEach((i) => {
      i.options[0].selected = true;
    });
    props.clearInforms();
  };

  return (
    <div className={`servicesWrapper mobile ${props.maxWidth ? "maxWidth" : ""}`}>
      <div className="titleWrapper">
        <h4 className="title">فروشندگان</h4>
        <div className="selectWrapper">
          <select
            onChange={(e) => {
              props.getCityHandler(e.target.value);
              props.setFilter("province", e.target.value);
            }}
            className="serviceOptions"
          >
            <option value="" disabled selected>
              استان
            </option>
            {props.locations.provinces ? (
              props.locations.provinces.map((item) => {
                return (
                  <option key={item.id} value={item.nstwProvinceId}>
                    {item.name}
                  </option>
                );
              })
            ) : (
              <option disabled>لطفا صبر کنید</option>
            )}
          </select>
          <select
            onChange={(e) => {
              props.setFilter("city", e.target.value);
            }}
            className="serviceOptions"
          >
            <option value="" disabled selected>
              شهر
            </option>
            {props.locations.cities ? (
              props.locations.cities.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })
            ) : (
              <option disabled>لطفا ابتدا استان را انتخاب کنید</option>
            )}
          </select>
          <div
            className="clear"
            onClick={() => {
              showAllhandler();
            }}
          >
            همه شهر ها
          </div>
        </div>
      </div>
      {props.data.length > 0 ? (
        props.data.map((item, index) => {
          return (
            <div className="serviceItem" key={index}>
              <div className="contentWrapper">
                <div className="column first">
                  {item.hasDiscount && (
                    <>
                      <div className="offBadge">{item.discountPercentage}%</div>
                      <p className="serviceName discountText">
                        پایان تخفیف تا {item.endManipulatedDiscountDateTime} دیگر
                      </p>
                    </>
                  )}
                  <p className="serviceName">{item.name}</p>
                  <div className="serviceManager">
                    استان : {item.province} , شهر : {item.city}
                  </div>
                  <div className="serviceAddress">آدرس : {item.address}</div>
                  <div className="serviceAddress">شماره تماس : {item.telephone}</div>
                </div>
                <div className={`column priceColumn ${item.fPrice === 0 || item.aPrice === 0 ? "fullWidth" : ""}`}>
                  {item.fPrice !== 0 && (
                    <div className={`priceWrapper ${item.aPrice !== 0 && "first"}`}>
                      <div className="serviceName">
                        قیمت آزاد <pre className="unit"> ({item.unit})</pre>
                      </div>
                      <div className="serviceDiscount"></div>
                      {item.hasDiscount ? (
                        <del className="servicePrice hasDiscount">{Config.separate(item.fPrice)} ریال</del>
                      ) : (
                        <div className="servicePrice">{Config.separate(item.fPrice)} ریال</div>
                      )}
                      {item.hasDiscount && (
                        <div className="servicePrice">{Config.separate(item.fPriceAfterDiscount)} ریال</div>
                      )}
                      <button
                        className="addToCart addToCartBtn"
                        onClick={(e) => {
                          addToCartHandler(
                            false,
                            item.id,
                            e,
                            item.hasDiscount ? item.fPriceAfterDiscount : item.fPrice,
                            item.providerId
                          );
                        }}
                      >
                        <FaShoppingCart /> افزودن به سبد خرید
                      </button>
                    </div>
                  )}
                  {item.aPrice !== 0 && (
                    <div className="priceWrapper">
                      <div className="serviceName">
                        قیمت دولتی <pre className="unit"> ({item.unit})</pre>
                      </div>
                      <div className="serviceDiscount"></div>
                      <div className="servicePrice">{Config.separate(item.aPrice)} ریال</div>
                      <button
                        className="addToCart addToCartBtn"
                        onClick={(e) => addToCartHandler(true, item.id, e, item.aPrice, item.providerId)}
                      >
                        <FaShoppingCart /> افزودن به سبد خرید
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="serviceMapWrapper">
                <ShowMap
                  height={200}
                  defaultCenter={[parseFloat(item.lat), parseFloat(item.long)]}
                  anchor={[parseFloat(item.lat), parseFloat(item.long)]}
                />
              </div>
            </div>
          );
        })
      ) : (
        <div className="noItemWrapper">
          <img className="noItem" src={noItemImg} />
          <p className="noText">هیچ موردی یافت نشد</p>
        </div>
      )}
    </div>
  );
};

export default React.memo(withRouter(Service));
